<template>
  <div :class="['emd-alert', '_color_danger', items.length > 0 ? 'displayFeedback' : 'hideFeedback']">
    <ul>
      <li class="emd-text" v-for="(error, index) in items" :key="index">{{error.message}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'ErrorList',
  props: ['items']
}
</script>
<style scoped>
</style>
